// extracted by mini-css-extract-plugin
export default {"host":"PrimaryButtonRounded_host__+kEz1"};